import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ImageButtonList from "../common/imageButtonList";
import ImageText from "../common/imageText";
import NavigationBar from "../common/navigationBar";

class RevenueCenters extends Component {
  /**************
   * Properties *
   **************/
  emptyImage = require("../common/images/empty.png");
  state = {
    navigationBar: {
      mainMenu: true,
      back: true,
      backRoute: "/main_menu",
    },
    header: {
      id: "header",
      src: require("./images/hdr_shopping.png"),
    },
    buttons: [
      {
        id: "pharmacy",
        highlight: require("./images/Intro_Pharmacy_HL.png"),
        unhighlight: require("./images/Intro_Pharmacy_UH.png"),
        highlight2: require("./images/Intro_Pharmacy_Text.png"),
        unhighlight2: this.emptyImage,
        alt: "Retail Pharmacy",
        checked: false,
      },
      {
        id: "giftShop",
        to: "/retail_shopping/revenue_center/gift_shop",
        highlight: require("./images/Intro_GiftShop_HL.png"),
        unhighlight: require("./images/Intro_GiftShop_UH.png"),
        highlight2: require("./images/Intro_GiftShop_Text.png"),
        unhighlight2: this.emptyImage,
        alt: "Gift Shop",
        checked: false,
      },
      {
        id: "medicalEquipment",
        to: "/retail_shopping/revenue_center/medical",
        highlight: require("./images/Intro_MedicalEquip_HL.png"),
        unhighlight: require("./images/Intro_MedicalEquip_UH.png"),
        highlight2: require("./images/Intro_MedicalEquip_Text.png"),
        unhighlight2: this.emptyImage,
        alt: "Medical Equipment",
        checked: false,
      },
    ],
    buttonList: {
      top: 111,
      left: 54,
    },
  };

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1350">
        <ImageText {...this.state.header} />
        <ImageButtonList
          {...this.state.buttonList}
          imageButtons={this.state.buttons}
        />
        <NavigationBar {...this.state.navigationBar} />
      </div>
    );
  }
}

export default withRouter(RevenueCenters);
